<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <div class="p-3">
            <h5>IPO Performance</h5>

            <h2 class="main-title">
              {{ content.title }}
            </h2>
            <p class="text-muted text-right">As of {{ today }}</p>
            <div class="row">
              <div class="col-lg-8 col-md-8 col-12"></div>
            </div>

            <div class="table-responsive mt-3">
              <sorted-table
                :values="content.ipoPerformance"
                class="table secondary-table table-bordered text-nowrap"
              >
                <thead>
                  <tr>
                    <th scope="col" class="text-center">
                      <sort-link name="board">Board</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="symbol">Stock Symbol</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="company">Company</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="listingDate">Listing Date</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="offerPrice">Offer Price</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="highestPrice">Highest Price</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="currentPrice">Current Price</sort-link>
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="firstDayPerformance"
                        >First Day Performance</sort-link
                      >
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="performanceAfter1st5days"
                        >Performance After 1st 5 Days</sort-link
                      >
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="offerVsHighestPrice"
                        >Offer Vs Highest Price</sort-link
                      >
                    </th>
                    <th scope="col" class="text-center">
                      <sort-link name="listingToDatePerformance"
                        >Listing to Date Performance</sort-link
                      >
                    </th>
                  </tr>
                </thead>
                <template #body="sort">
                  <tbody  v-if="!isDataLoaded">
                    <tr v-for="(item, index) in sort.values" :key="index">
                      <td class="text-left">{{ item.board }}</td>
                      <td class="text-left">
                        <b>{{ item.symbol }}</b>
                      </td>
                      <td class="text-left">{{ item.company }}</td>
                      <td class="text-right">{{ FormatDate(item.listingDate) }}</td>
                      <td class="text-right">{{ FormatPrices(item.offerPrice) }}</td>
                      <td class="text-right">{{ FormatPrices(item.highestPrice) }}</td>
                      <td class="text-right">{{ FormatPrices(item.currentPrice) }}</td>
                      <td
                        class="text-right"
                         :style="ColorCode(item.firstDayPerformance)"
                      >
                        {{ FormatYield(item.firstDayPerformance) }}%
                      </td>
                      <td
                        class="text-right"
                        :style="ColorCode(item.performanceAfter1st5days)"
                      >
                      {{ FormatYield(item.performanceAfter1st5days) }} %
                      </td>
                  
                      <td
                        class="text-right"
                       :style="ColorCode(item.offerVsHighestPrice)"
                      >
                        {{ FormatYield(item.offerVsHighestPrice) }} %
                      </td>
                      <td
                        class="text-right"
                        :style="ColorCode(item.listingToDatePerformance)"
                      >
                        {{ FormatYield(item.listingToDatePerformance) }} %
                      </td>
                    </tr>
                  </tbody>
                </template>
              </sorted-table>

              <div v-if="!isDataLoaded && content.ipoPerformance.length == 0">
                   <Noresult/>
              </div>

              <b-skeleton-table
                :rows="19"
                :columns="12"
                :table-props="{ bordered: true, striped: true }"
                v-if="isDataLoaded"
              ></b-skeleton-table>
            </div>

            <h5 class="sub-title-page">{{ content.articleLabel }}</h5>

            <div v-for="(item, index) in content.templates" :key="index">
              <div v-if="item.contentType == 'string'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>

              <div v-if="item.contentType == 'date'">
                <p class="text-muted" v-html="FormatDate(item.content)"></p>
              </div>

              <div v-if="item.contentType == 'image'" class="image-umbraco">
                <b-img
                  class="img-thumbnail"
                  :src="'data:image/jpeg;base64,' + item.content"
                  fluid-grow
                  alt="Fluid-grow image"
                ></b-img>
              </div>
              <div class="table table-umbraco" v-if="item.contentType == 'table'">
                <p v-html="item.content"></p>
              </div>
               <bullMeter
                  :slider="ConvertValue(item.content)"
                  v-if="item.contentType == 'slider'"
                />
 
              <div v-if="item.contentType == 'link'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>
            </div>

            <a href="javascript:void(0)" @click="ViewArchive()">
              View IPO Performance Archive
            </a>
            <Disclaimer />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import navHeader from "../../ResearchPages/NavHeader";
import Disclaimer from "../ReportsPages/Disclaimer";
import Noresult from "../NoResult.vue"; 
import { mapState } from "vuex";
import Footer from "../Footer";
import moment from "moment";
import bullMeter from "../BullMeter/BullMeter.vue";
export default {
  components: {
    Disclaimer,
    navHeader,
    Footer,
    Noresult, 
    bullMeter
  },

  data() {
    return { isDataLoaded: false, hasError: false, today:moment().format("LLL"), values: [], color: 'color:#00ff00;"' };
  },
  computed: {
    ...mapState({
      content: (state) => state.philstocksResearch.ipoPerformanceContent,
    }),
  },
  methods: {
    GoogleAnalytics() {
      this.$gtag.event("IPOPerformance", { method: "Google" });
    },
    FormatPrices(data) {
      var price = parseFloat(data);

      if (price == 0) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else if (price < 0.51) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        });
      } else if (price >= 1000) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else if (price == undefined || isNaN(price)) {
        return 0;
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    ViewArchive() {
      this.isDataLoaded = true;
      this.content.ipoPerformance = [];
      this.$router.push("/Reports/Archive/IPOPerformance");
      
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
    FormatDateTime(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("LLL");
      }
      return result;
    },

     ConvertValue(data) {
      var value = parseInt(data);
     return value;
    },
    FormatYield(data) {
      var price = parseFloat(data);
      if (isNaN(price) || price == 0) {
        return 0;
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    ColorCode(data) {
      var result = "";
      if (data != undefined || data != null) {
        var price = parseFloat(data);

        if (price > 0) {
          result = 'color:green;"';
        } else if (price < 0) {
          result = 'color:red;"';
        } else {
          result = "'color:black';";
        }
        return result;
      } else {
        return (result = "'color:black';");
      }
    },

    async GetIPOPerformanceContent(data) {
      var isResponseError = false;
      this.isDataLoaded = true;
     
     this.$store.state.philstocksResearch.ipoPerformanceContent = {};
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetIPOPeformance", data)
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;
          _this.hasError = true

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },
  async mounted() {
    this.GetIPOPerformanceContent(this.$route.query.date);
  },
};
</script>

<style></style>
